/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../core';
import * as errors from '../../errors/index';
import * as Truvity from '../index';

export class BadRequestError extends errors.TruvityError {
    constructor(body: Truvity.BadRequestProblems, rawResponse?: core.RawResponse) {
        super({
            message: 'BadRequestError',
            statusCode: 400,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, BadRequestError.prototype);
    }
}
